import React, { useMemo } from 'react';
import { Keyboard, View } from 'react-native';
import { Button, ButtonGroup, rem, SettingsItem } from 'design-system';
import { IconArrowBack } from 'design-system/icons';
import IconPieChart from 'design-system/icons/IconPieChart';
import Modal from 'utils/packages/Modal';
import { useRefCallback } from 'hooks';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { selectDefaultCurrency } from 'reducers/selectors';
import getSymbolFromCurrency from 'currency-symbol-map';
import PopUpMenuModal, { defaultPopUpWidth, } from 'design-system/PopUpMenuModal.web';
import Text from 'design-system/Text';
import { isWeb } from '../../../constants';
export const useClearCategoryBudgetsModal = ({ onClearBudgetPress, onClearRollingPress, isRolling, btnViewRef, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const defaultCurrency = useAppSelector(selectDefaultCurrency);
    const currencySymbol = useMemo(() => getSymbolFromCurrency(defaultCurrency), [defaultCurrency]);
    const showClearRollingCategoriesOrAllModal = () => {
        Modal.show(<View>
        <Text TextThin-14 Secondary centered style={styles.modalText}>
          {`You have rolled over amounts in both your category budgets and your total budget. How would you like to reset them?`}
        </Text>
        <ButtonGroup margins={false}>
          <Button brandReversed title={'Reset category budgets only'} onPress={() => {
                onClearRollingPress();
                Modal.hide();
            }}/>

          <Button brand title={`Reset all rolled amounts`} onPress={() => {
                onClearRollingPress(true);
                Modal.hide();
            }}/>
        </ButtonGroup>
      </View>, {
            title: 'Reset rolled over amount',
        });
    };
    return useRefCallback(() => {
        Keyboard.dismiss();
        if (isRolling) {
            if (isWeb && btnViewRef?.current) {
                btnViewRef?.current?.measure((_, __, ___, ____, fx, fy) => {
                    PopUpMenuModal.show(<View>
              <SettingsItem title="Clear category budget" description={`This will set all category budgets to ${currencySymbol}0.00`} icon={<IconPieChart gradientKey="deepPink"/>} onPress={() => {
                            onClearBudgetPress();
                            PopUpMenuModal.hide();
                        }}/>
              <SettingsItem title="Reset rolled over amount" description="This will set all category budgets to the default amount" icon={<IconArrowBack color={colors.status.offline}/>} onPress={() => PopUpMenuModal.hide(() => {
                            showClearRollingCategoriesOrAllModal();
                        })}/>
            </View>, {
                        fx: fx - defaultPopUpWidth,
                        fy: fy + rem(40),
                    });
                });
            }
            else {
                Modal.show(<View>
            <SettingsItem title="Clear category budget" description={`This will set all category budgets to ${currencySymbol}0.00`} icon={<IconPieChart gradientKey="deepPink"/>} onPress={() => {
                        onClearBudgetPress();
                        Modal.hide();
                    }}/>
            <SettingsItem title="Reset rolled over amount" description="This will set all category budgets to the default amount" icon={<IconArrowBack color={colors.status.offline}/>} onPress={() => Modal.hide(() => {
                        showClearRollingCategoriesOrAllModal();
                    })}/>
          </View>, {
                    containerStyle: styles.container,
                    title: 'Clear',
                });
            }
        }
        else {
            Modal.show(<View>
          <Text TextThin-14 Secondary centered style={styles.modalText}>
            {`Do you want to reset category budgets? This will set all category budgets to ${currencySymbol}0.00`}{' '}
          </Text>
          <ButtonGroup margins={false}>
            <Button brandReversed title={'No, thanks'} onPress={() => Modal.hide()}/>

            <Button brand title={`Yes, let’s clear`} onPress={() => {
                    onClearBudgetPress();
                    Modal.hide();
                }}/>
          </ButtonGroup>
        </View>, {
                title: 'Clear category budgets',
            });
        }
    });
};
const styleSet = createStyleSheets(() => ({
    container: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    modalText: {
        marginVertical: rem(16),
    },
    webModalTitle: {
        marginTop: rem(16),
    },
}));
